// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue_container[data-v-7d25c1dc]{height:calc(100vh - 50px);width:calc(100vw - 225px);overflow-y:scroll;margin-left:225px;background:var(--background-color)}.navbar_view[data-v-7d25c1dc]{z-index:1000;position:fixed;top:0;left:0;right:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
